import { Box } from '../../../core/Components'
import { Graphics, topGraphics } from '../../../core/Graphics'
import { Subtitle } from '../../../core/Subtitle'
import { Title } from '../../../core/Title'
import StyledProgressContainer from '../Progress'

export const MintLoader = () => {
  return (
    <Box css={{ padding: '10px', width: '500px' }}>
      <Graphics className={topGraphics()} />
      <Title>Minting in progress</Title>
      <Subtitle>Please wait...</Subtitle>
      <StyledProgressContainer infinite />
    </Box>
  )
}
